import KeysPipeline from "./KeysPipeline/KeysPipeline";
import Hashes from "./Hashes/Hashes";
import Hex from "./Hex/Hex";
import UnitConverter from "./UnitConverter/UnitConverter";
import AddressFormatter from "./AddressFormatter/AddressFormatter";
import CliMappings from "./CliMappings/CliMappings";
import EvmWords from "./EvmWords/EvmWords";
import EcRecover from "./EcRecover/EcRecover";

export default {
    name: 'off-chain-tools',
    template: require('./OffChainTools.html'),
    components: { KeysPipeline, Hashes, Hex, UnitConverter, AddressFormatter, CliMappings, EvmWords, EcRecover }
}
